import { ref as f, computed as b, onMounted as k, onBeforeUnmount as B, watch as C, openBlock as O, createElementBlock as T, createElementVNode as v, renderSlot as p, createTextVNode as c, normalizeClass as w } from "vue";
import { onClickOutside as g } from "./design-system.es125.js";
/* empty css                    */
import I from "./design-system.es128.js";
import { createPopper as L } from "./design-system.es297.js";
const N = {
  name: "DsTooltipLegacy",
  props: {
    isOpen: {
      type: Boolean,
      default: null
    },
    /**
     * Position of the tooltip relative to its reference
     */
    position: {
      type: String,
      default: "bottom",
      options: ["top", "right", "bottom", "left"]
    },
    /**
     * Boolean to be able to disable a tooltip from being able to open
     */
    disabled: Boolean,
    /**
     * Boolean to force tooltips to wrap with max width
     */
    wrap: Boolean,
    /**
     * Delay in ms before the tooltip opens.  Boolean true will default to 300ms.
     */
    delay: {
      type: [Number, Boolean],
      default: !1
    }
  },
  emits: ["close"],
  setup(n, { emit: e }) {
    const a = f(null), l = f(null), i = f(!1), t = f(null), o = f(null), r = b(() => n.isOpen === !0 || n.isOpen === !1);
    function d() {
      i.value = !1, t.value && t.value.update();
    }
    function u() {
      i.value = !0, t.value && t.value.update();
    }
    function m() {
      if (!r.value) {
        if (!n.delay)
          u();
        else if (!o.value) {
          const s = n.delay === !0 ? 300 : n.delay;
          o.value = setTimeout(() => {
            u(), clearTimeout(o.value), o.value = null;
          }, s);
        }
      }
    }
    function y() {
      r.value || (clearTimeout(o.value), o.value = null, d());
    }
    function M() {
      r.value || (clearTimeout(o.value), o.value = null, u());
    }
    return g(
      a,
      (s) => {
        i.value && (r.value ? e("close", s) : d());
      },
      { ignore: [l] }
    ), k(() => {
      t.value = L(l.value, a.value, {
        placement: n.position,
        modifiers: [
          {
            name: "eventListeners",
            options: {
              scroll: !0,
              resize: !0
            }
          },
          {
            name: "offset",
            options: {
              offset: [0, 8]
            }
          }
        ]
      });
    }), B(() => {
      t.value && typeof t.value.destroy == "function" && t.value.destroy(), t.value = null;
    }), C(
      () => n.isOpen,
      (s) => {
        s ? u() : d();
      },
      { immediate: !0 }
    ), {
      tooltip: a,
      reference: l,
      isOpenInternal: i,
      popperJs: t,
      isControlled: r,
      close: d,
      open: u,
      onMouseover: m,
      onMouseleave: y,
      onClick: M
    };
  }
}, x = { class: "tooltip-container" };
function z(n, e, a, l, i, t) {
  return O(), T("div", x, [
    v("div", {
      ref: "reference",
      class: "tooltip-reference",
      onMouseover: e[0] || (e[0] = (...o) => l.onMouseover && l.onMouseover(...o)),
      onMouseleave: e[1] || (e[1] = (...o) => l.onMouseleave && l.onMouseleave(...o)),
      onClick: e[2] || (e[2] = (...o) => l.onClick && l.onClick(...o))
    }, [
      p(n.$slots, "reference")
    ], 544),
    e[5] || (e[5] = c()),
    v("section", {
      ref: "tooltip",
      class: w(["tooltip", [{ open: l.isOpenInternal, disabled: a.disabled, wrap: a.wrap }]])
    }, [
      e[3] || (e[3] = v("div", {
        "data-popper-arrow": "",
        class: "arrow"
      }, null, -1)),
      e[4] || (e[4] = c()),
      p(n.$slots, "default")
    ], 2)
  ]);
}
const P = /* @__PURE__ */ I(N, [["render", z], ["__scopeId", "data-v-bcf66ff4"]]);
export {
  P as default
};
//# sourceMappingURL=design-system.es330.js.map
